import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { AiToolbar } from '../../../../components/AiToolbar/AiToolbar.jsx';
import { MarkdownTextAi } from '../../../../components/messages/UserMessage/Markdown/MarkdownText.jsx';

const TextBlock = ({
  text,
  isMobile = false,
}: {
  text: string;
  isMobile?: boolean;
}) => {
  return (
    <div
      className={cn(
        'group relative flex flex-col',
        isMobile ? 'gap-4' : 'gap-1',
      )}
    >
      <MarkdownTextAi
        className={cn(
          isMobile
            ? 'text-[16px] leading-[150%] font-normal text-text-primary'
            : typographyVariants({ variant: 'bodyLong01', color: 'primary' }),
        )}
        text={text.replaceAll(/ {2,}/g, ' ')}
      />
      <AiToolbar text={text} isMobile={isMobile} />
    </div>
  );
};

export { TextBlock };
